<template lang="pug">
.flag-currency
  template(v-if="currency.toUpperCase() == 'USD'")
    i.flag-icon.flag-icon-us.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'THB'")
    i.flag-icon.flag-icon-th.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'IDR'")
    i.flag-icon.flag-icon-id.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'VND'")
    i.flag-icon.flag-icon-vn.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'CNY'")
    i.flag-icon.flag-icon-cn.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'HKD'")
    i.flag-icon.flag-icon-hk.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'SGD'")
    i.flag-icon.flag-icon-sg.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'KRW'")
    i.flag-icon.flag-icon-kr.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'AUD'")
    i.flag-icon.flag-icon-au.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'INR'")
    i.flag-icon.flag-icon-in.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'MMK'")
    i.flag-icon.flag-icon-mm.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'MMO'")
    i.flag-icon.flag-icon-mm.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'BDT'")
    i.flag-icon.flag-icon-bd.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'EUR'")
    i.flag-icon.flag-icon-eu.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'TND'")
    i.flag-icon.flag-icon-tn.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'ARS'")
    i.flag-icon.flag-icon-ar.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'BND'")
    i.flag-icon.flag-icon-bn.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'PKR'")
    i.flag-icon.flag-icon-pk.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'GOO'")
    i.flag-icon.flag-icon-go.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'UST'")
    i.flag-icon.flag-icon-usdt.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'LAK'")
    i.flag-icon.flag-icon-la.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'JPY'")
    i.flag-icon.flag-icon-jp.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'NPR'")
    i.flag-icon.flag-icon-np.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'BRL'")
    i.flag-icon.flag-icon-br.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'LKR'")
    i.flag-icon.flag-icon-lk.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else-if="currency.toUpperCase() == 'MNT'")
    i.flag-icon.flag-icon-mn.align-middle
    span.text-uppercase #[b {{ currency }} ]
  template(v-else)
    i.flag-icon.flag-icon-my.align-middle
    span.text-uppercase #[b {{ currency }} ]
</template>

<script>
export default {
  props: {
    currency: ""
  }
};
</script>
